

































































import Vue from 'vue';

interface Auditor {
  id: string;
  name: string;
  avatar: string | null;
}

interface Outlet {
  id: string;
  name: string;
  logo: string;
}

export default Vue.extend({
  props: {
    auditor: {
      type: Object as () => Auditor | null,
    },

    outlet: {
      type: Object as () => Outlet,
      required: true,
    },
  },

  computed: {
    auditorName(): string {
      return this.auditor ? this.auditor.name : 'Unassigned';
    },

    avatarUrl(): string | null {
      return this.auditor ? this.auditor.avatar : null;
    },

    outletLogo(): string {
      return this.outlet.logo;
    },

    outletName(): string {
      return this.outlet.name;
    },
  },
});
